// Crockford-style base32 alphabet (no 0/O/1/I confusion). 16 chars ≈ 80 bits of entropy.
const ALPHABET = "abcdefghjkmnpqrstvwxyz23456789";

export function generateBabyId(length = 16): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < length; i++) {
    out += ALPHABET[bytes[i] % ALPHABET.length];
  }
  return out;
}

// The "which baby was I looking at" pointer is scoped per signed-in account.
// It used to be one unscoped key, which meant a second account signing in on
// the same device inherited the previous account's baby — and, worse, that a
// wiped key sent everyone through the guess-a-baby path in Landing. Scope it,
// and sweep the legacy key so nothing reads it again.
const LEGACY_KEY = "babyhelper:lastBabyId";

function keyFor(userId: string): string {
  return `${LEGACY_KEY}:${userId}`;
}

function dropLegacy(): void {
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    /* ignore */
  }
}

export const lastUsedBabyId = {
  get(userId: string | null | undefined): string | null {
    if (!userId) return null;
    try {
      return localStorage.getItem(keyFor(userId));
    } catch {
      return null;
    }
  },
  set(userId: string | null | undefined, id: string): void {
    if (!userId) return;
    try {
      localStorage.setItem(keyFor(userId), id);
      dropLegacy();
    } catch {
      /* ignore */
    }
  },
  clear(userId: string | null | undefined): void {
    try {
      if (userId) localStorage.removeItem(keyFor(userId));
      dropLegacy();
    } catch {
      /* ignore */
    }
  },
};
